// extracted by mini-css-extract-plugin
export var adjacentSlide = "_oj-9";
export var arrowButtonContainer = "_oj-5";
export var arrowButtonIcon = "_oj-6";
export var carouselArrowButton = "_oj-2";
export var carouselElementContainer = "_oj-1";
export var currentSlide = "_oj-8";
export var left = "_oj-3";
export var otherSlide = "_oj-a";
export var productCarouselContainer = "_oj-0";
export var right = "_oj-4";
export var sliderOverflow = "_oj-7";